import { DropdownField } from "../../../../../Common/DropdownField/DropdownField";
import {
  dropdownOptionToValue,
  selectedDropdownOption,
} from "../../../../../Common/selectDropdownOption";
import {
  DropdownOption,
  ComputedFieldProps,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../../../../intl";
import { Option } from "fp-ts/Option";
import { option, record } from "fp-ts";
import { pipe, constant } from "fp-ts/function";
import { useFormatEmploymentType } from "../../../../../StandardLoan/IncomeForm/domain";
import { EmploymentType } from "../../../api";
import { ReadOnlyFieldToValue } from "../../../../../Common/ReadOnlyField/ReadOnlyFieldToValue";

type Props = {
  fieldProps: ComputedFieldProps<Option<EmploymentType>>;
};
export function EmploymentTypeDropdown({ fieldProps }: Props) {
  const formatMessage = useFormatMessage();
  const formatEmploymentType = useFormatEmploymentType();

  const dropdownOptions: Array<DropdownOption<EmploymentType>> = pipe(
    EmploymentType.keys,
    record.collect(employmentType => ({
      value: employmentType,
      label: formatEmploymentType(employmentType),
    }))
  );

  const onChange = (dropdownOption: Option<DropdownOption<EmploymentType>>) => {
    fieldProps.onChange(dropdownOptionToValue(dropdownOption));
  };

  const value = selectedDropdownOption(fieldProps.value, dropdownOptions);

  return fieldProps.disabled ? (
    <ReadOnlyFieldToValue
      value={pipe(
        value,
        option.map(({ label }) => String(label)),
        option.getOrElse(constant(""))
      )}
      label={formatMessage("Mortgage.Bonita.Income.Contract.employmentType")}
    />
  ) : (
    <DropdownField
      {...fieldProps}
      clearable={false}
      label={formatMessage("Mortgage.Bonita.Income.Contract.employmentType")}
      onChange={onChange}
      options={dropdownOptions}
      placeholder={formatMessage(
        "Mortgage.Bonita.Income.Contract.employmentTypePlaceholder"
      )}
      searchable={false}
      value={value}
    />
  );
}
